export const FLOW_STATE_OPTIONS = ['default', 'warning', 'problem', 'fixing', 'finished']